/* __next_internal_client_entry_do_not_use__ BrandInsightsTileContents auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { buildElementLoggingData } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/EventLogging/buildLoggingData";
import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIAvatarElementRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Avatar/SDUIAvatarElementRenderer";
import { SDUIImageElementRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Image/SDUIImageElementRenderer";
import { SDUIRichTextRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/RichText/SDUIRichTextRenderer";
import { useProductTileViewImpression } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileViewImpression";
import { VERTICAL_ASPECT_RATIO } from "@faire/retailer-visitor-shared/lib/verticalAspectRatio";
import { Button } from "@faire/web--source/slate/Button";
import { Close } from "@faire/web--source/slate/icons/Close";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { IImageElement } from "@faire/web-api--source/indigofair/data/IImageElement";
import React from "react";
export var BrandInsightsTileContents = /*#__PURE__*/ React.memo(function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData, onMuteClick = param.onMuteClick;
    var on_click = tileElement.on_click, brand_insights_tile = tileElement.brand_insights_tile;
    var _ref = brand_insights_tile !== null && brand_insights_tile !== void 0 ? brand_insights_tile : {}, brand_avatar = _ref.brand_avatar, title = _ref.title, products = _ref.products, metadata = _ref.metadata, brand_title_on_click = _ref.brand_title_on_click;
    if (!brand_avatar || !title || !(products === null || products === void 0 ? void 0 : products.length) || !metadata) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        className: "border-core-border-muted flex w-full flex-col gap-4 border p-4",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                align: "start",
                justify: "space-between",
                gap: 12,
                children: [
                    /*#__PURE__*/ _jsxs(SDUIOnClickHandler, {
                        onClickActions: brand_title_on_click !== null && brand_title_on_click !== void 0 ? brand_title_on_click : [],
                        loggingData: loggingData,
                        logLegacyClickEvent: true,
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(SDUIAvatarElementRenderer, {
                                avatarElement: brand_avatar,
                                loggingData: loggingData
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                maxLines: 2,
                                as: "span",
                                children: /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                                    richTextElement: title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        "aria-label": "Mute brand",
                        variant: "tertiary",
                        onClick: onMuteClick,
                        children: /*#__PURE__*/ _jsx(Close, {
                            color: Core.icon.subdued,
                            "aria-label": "Close button to mute brand updates"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Row, {
                gap: "1x",
                children: products.map(function(simpleProductTile) {
                    var _simpleProductTile_product_token;
                    return simpleProductTile.image ? /*#__PURE__*/ _jsx(SimpleInsightsTileProduct, {
                        simpleProductTile: simpleProductTile,
                        loggingData: loggingData
                    }, (_simpleProductTile_product_token = simpleProductTile.product_token) !== null && _simpleProductTile_product_token !== void 0 ? _simpleProductTile_product_token : "brand-insights-see-more-tile") : null;
                })
            })
        ]
    });
});
var SimpleInsightsTileProduct = function(param) {
    var simpleProductTile = param.simpleProductTile, loggingData = param.loggingData;
    // if product_token is undefined, it's the "see more" tile and should not be counted as a product impression
    var isProductTile = simpleProductTile.product_token !== undefined;
    var _simpleProductTile_product_token, _simpleProductTile_impression_id;
    var _useProductTileViewImpression = useProductTileViewImpression({
        productToken: (_simpleProductTile_product_token = simpleProductTile.product_token) !== null && _simpleProductTile_product_token !== void 0 ? _simpleProductTile_product_token : "",
        impressionId: (_simpleProductTile_impression_id = simpleProductTile.impression_id) !== null && _simpleProductTile_impression_id !== void 0 ? _simpleProductTile_impression_id : "",
        turnOffTracking: !isProductTile
    }), trackProductTileViewRef = _useProductTileViewImpression.ref, restTrackProductTileViewProps = _object_without_properties(_useProductTileViewImpression, [
        "ref"
    ]);
    var _simpleProductTile_image;
    var productImageElement = (_simpleProductTile_image = simpleProductTile.image) !== null && _simpleProductTile_image !== void 0 ? _simpleProductTile_image : IImageElement.build();
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: "relative h-full w-full",
        "data-test-id": "brand-insights-tile-product-".concat(simpleProductTile.product_token),
        ref: isProductTile ? trackProductTileViewRef : undefined
    }, isProductTile ? restTrackProductTileViewProps : {}), {
        children: /*#__PURE__*/ _jsx(SDUIImageElementRenderer, {
            imageElement: productImageElement,
            imageStyles: {
                aspectRatio: VERTICAL_ASPECT_RATIO,
                height: "100%",
                width: "100%"
            },
            loggingData: buildElementLoggingData(loggingData, productImageElement.logging_data)
        })
    }));
};
